export default "__VITE_ASSET__b95bfe40__"